import { EventEmitter, Inject, Injectable } from "@angular/core";

import { City, Client, Profile, ProfileJob } from "@salaxy/core";

import { ClientNg } from "../api/ClientNg";
import { SessionService } from "../account/SessionService";

/* tslint:disable */
/*
  TODO: Waiting for Go-through

  - Potentially implement ISingleItemRepository.
  - Or it may also be that we remove this service completely.

*/

/** Repository for managing user Worker profile pages data (osaajaprofiili) */
@Injectable()
export class MyProfileRepository {



    /** Current profile */
    public myProfile: Profile;

    /** List of Jobs for editor component */
    public jobsForEdit: ProfileJob[];

    /** List of cities for editor component */
    public citiesForEdit: City[];

    /** Creates a new instance of MyProfileRepository with dependency injection. */
    constructor(
        @Inject(ClientNg) private client: Client,
    ) { }

    /**
     * Assures the repository initialization:
     * Initialization is done after successful authentication.
     * Typically the call to fetch the repository list, but may fetch other stuff from the server.
     *
     * @param session - The session service that contains information about the authenticated user.
     */
    public init(session: SessionService) {
        this.reloadMyProfile();
        this.getJobsForEdit();
        this.getCitiesForEdit();
    }

    public reloadMyProfile() {
        this.client.profilesApi.getMyProfile((profile) => {
            this.myProfile = profile;
        });
    }

    public save(callback?) {
        if (this.myProfile) {
            this.client.profilesApi.saveMyProfile(this.myProfile, (savedProfile) => {
                this.myProfile = savedProfile;
                if (callback) {
                    callback();
                }
            });

        }
    }

    public getJobsForEdit() {
        if (this.jobsForEdit == null) {
            this.jobsForEdit = [];
            this.client.profilesApi.getJobs( (data) => {
                this.jobsForEdit = data;
            });
        }
        return this.jobsForEdit;
    }

    public getCitiesForEdit() {
        if (this.citiesForEdit == null) {
            this.citiesForEdit = [];
            this.client.profilesApi.getCities( (data) => {
                this.citiesForEdit = data;
            });
        }
        return this.citiesForEdit;
    }
}
